import { render, staticRenderFns } from "./KeyValue.vue?vue&type=template&id=04c66839&scoped=true"
import script from "./KeyValue.vue?vue&type=script&lang=js"
export * from "./KeyValue.vue?vue&type=script&lang=js"
import style0 from "./KeyValue.vue?vue&type=style&index=0&id=04c66839&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c66839",
  null
  
)

export default component.exports